<script>
	import Dialog, { Title, Content, Actions, InitialFocus } from "@smui/dialog";
	import Button, { Label } from "@smui/button";

	export let open;
</script>

<Dialog bind:open aria-labelledby="default-focus-title" aria-describedby="default-focus-content">
	<Title id="default-focus-title">Delete for all eternity?</Title>
	<Content id="default-focus-content"
		>Are you sure you want to
		<strong class="secondary">permanently delete</strong> this version of the graphic and
		<strong class="secondary">break the embed code</strong>?</Content
	>
	<Actions>
		<Button defaultAction use={[InitialFocus]}>
			<Label>Cancel</Label>
		</Button>
		<Button on:click>
			<Label>Yes, delete it</Label>
		</Button>
	</Actions>
</Dialog>

<style lang="scss">
	strong {
		color: var(--mdc-theme-secondary);
	}
</style>
